import { render } from "./AppContainer.vue?vue&type=template&id=1fa24670&scoped=true"
import script from "./AppContainer.vue?vue&type=script&lang=js"
export * from "./AppContainer.vue?vue&type=script&lang=js"

import "./AppContainer.vue?vue&type=style&index=0&id=1fa24670&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1fa24670"

export default script